module.exports = __webpack_public_path__ + "media/discovery-ui/assets/tab-option-text-3dbc8acd69718445fafd0f628778b095.svg";